import * as React from "react";
const MonitoringIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#monitoring_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.385 37.8-7.18 7.18a4.115 4.115 0 1 0 5.82 5.82l7.18-7.18a24.008 24.008 0 0 1-5.82-5.82ZM31.005 4a20 20 0 1 0 18.48 12.345A19.995 19.995 0 0 0 31.005 4Zm11 30.18a15 15 0 1 1-21.999-20.395 15 15 0 0 1 22 20.395Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m42.42 22.586-6-6a2 2 0 1 0-2.829 2.828L36.177 22H21.005a2 2 0 1 0 0 4h15.172l-2.586 2.586a1.999 1.999 0 0 0 2.18 3.276 2 2 0 0 0 .648-.448l6-6a2 2 0 0 0 0-2.828Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "monitoring_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default MonitoringIcon;